import addressTranslations from 'features/personalInfo/confirmYourAddress/localization/AddressTranslations.en';

export default {
  addressTranslations,
};
